import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';

/**
 * A reusable confirmation dialog component aligned with MUI
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the dialog is open
 * @param {string} props.title - Dialog title
 * @param {string} props.message - Dialog message (can contain \n for multiple lines)
 * @param {string} props.confirmText - Text for confirm button
 * @param {string} props.cancelText - Text for cancel button
 * @param {Function} props.onConfirm - Function to call when confirmed
 * @param {Function} props.onCancel - Function to call when canceled
 * @returns {JSX.Element|null} - The confirmation dialog
 */
const ConfirmationDialog = ({ 
  isOpen, 
  title, 
  message, 
  confirmText = 'Xác nhận', 
  cancelText = 'Hủy', 
  onConfirm, 
  onCancel 
}) => {
  const lines = typeof message === 'string' && message.includes('\n')
    ? message.split('\n')
    : message ? [message] : [];

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth maxWidth="xs">
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent dividers>
        <Stack spacing={1}>
          {lines.length > 0 ? (
            lines.map((line, idx) => (
              <Typography key={idx} color="text.secondary">
                {line}
              </Typography>
            ))
          ) : (
            <Typography color="text.secondary">Bạn có chắc chắn?</Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text" color="inherit">
          {cancelText}
        </Button>
        {typeof onConfirm === 'function' && (
          <Button onClick={onConfirm} variant="contained" color="primary">
            {confirmText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;